/** @module faq */

/**
 * Initializes FAQ filter functionalities. Elements intended to filter FAQ items should have a class
 * `.faq__filter-button` with a `data-category` attribute.
 *
 * @param {object} [options={}] - Options for the FAQ filter.
 *
 * @return {Promise<void>} - Resolves immediately, if no element for FAQ filtering is on the page, or once
 * functionality is all set up.
 */
export async function faq(options = {}) {
    if (document.querySelector('.faq__filter-button')) {
        const { initFaq } = await import(/* webpackMode: "lazy" */ './inc/faq.async');

        initFaq(options);
    }
}
